import { AnchorNode } from '../anchor';
import { NodeTextNavigation } from './NodeTextNavigation';

export const getNodePathFromNodeOffset = (root: AnchorNode, domNode: Node, offset: number) => {
    const structNode = root.findClosestByNode(domNode);
    if (!structNode) { return null; }
    const documentNode = structNode.selfOrAncestorDocumentContent();
    if (!documentNode) { return null; }
    const nodeOffset = new NodeTextNavigation(domNode).forward(offset).countBackwards(structNode.node);
    return `${structNode.path}+${nodeOffset}`;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/getNodePathFromNodeOffset.tsx